/* eslint-disable prettier/prettier */
import TextArea from "antd/lib/input/TextArea";
import React from "react";

const DokanTextAreaField = ({ placeholder = "Placeholder Text" }) => {
  const handleChange = () => {};
  return (
    <TextArea
      className="mt-20px dokan-text-area"
      onChange={handleChange}
      placeholder={placeholder}
      autoSize={{ minRows: 5, maxRows: 7 }}
    />
  );
};

export default DokanTextAreaField;
